import { Language } from "../LanguageConfig";
import {DateFormat, DateTimeFormat} from "../../helpers/Formatting";
import deLocale from 'date-fns/locale/de';
import {format} from "date-fns";
import DateFnsUtils from "@date-io/date-fns";

export class DeLocalizedUtils extends DateFnsUtils {
    getDatePickerHeaderText(date: Date) {
        return format(date, "dd.MM.yyyy", { locale: deLocale });
    }
}




/**
 * base language, please see this language file to check how the text identifiers are named
 */
export const German: Language = {
    locale: 'de-DE',
    languageIdentifier: "german",
    language: "Sprache",
    common: {
        description: "Beschreibung",
        reason: "Begründung",
        form: {
            lockedValues: {
                title: "Werte einrasten",
                helpText: 'Wenn sie "Werte einrasten" wählen werden ausgewählte Formularwerte für weitere Eintragungen zwischengespeichert. Die Werte sind eingerastet bis sie diese entfernen!'
            },
            removeLockValues: "Eingerastete Werte entfernen"
        },
        contractor: "Auftragnehmer",
        control: "Kontrolle",
        mainMenu: "Hauptmenü",
        invoices: "Rechnungen",
        reports: "Berichte",
        immediately: "Sofort",
        replace: "Ersetzen",
        unsavedDataWarning: {
            title: "Seite wirklich verlassen?",
            helpText: "Sie haben eventuell ungespeicherte Daten. Diese gehen verloren, wenn sie die Seite verlassen oder sich ausloggen, wollen sie fortfahren?"
        },
        origin: "Ursprung",
        emptyCache: {
            buttonText: 'Lokalen Zwischenspeicher leeren',
            tooltipText: 'Der lokale Zwischenspeicher dieser Seite wird unwiederbringlich gelöscht. Alle ungespeicherten Daten gehen verloren.'
        },
        sender: "Absender",
        recipient: "Empfänger",
        status: "Status",
        solvencyReport: "Projekt Liquiditätsbericht",
        export: {
            tooltipText: "Exportieren sie die momentan angezeigten Daten.",
            buttonText: "Exportieren"
        },
        import: {
            tooltipText: "Importieren sie Daten ür die momentane Seite",
            buttonText: "Importieren"
        },
        total: 'Gesamt',
        summary: "Zusammenfassung",
        files: "Dateien",
        uploadFile: {
            buttonText: 'Datei hochladen',
            tooltipText: 'Wählen sie eine oder mehrere Dateien aus, welche sie an den Eintrag anhängen wollen.'
        },
        all: 'Alle',
        justSelected: 'Auch markierte',
        onlyCurrent: 'Nur diesen',
        remaining: 'Übrig',
        active: 'Aktiv',
        removeButton: {
            buttonText: 'Entfernen',
            tooltipText: 'Entfernen sie diese Auswahl'
        },
        not: 'Nicht',
        filterInvert: {
            buttonText: 'Invertiert',
            tooltipText: 'Invertieren sie die Auswahl. Beispiel: Wenn sie invertieren und das Projekt 0001 auswählen, werden alle Daten angezeigt, außer denen, welche zum gewählten Projekt gehören.'
        },
        add: 'Hinzufügen',
        internal: "Intern",
        stepBack: {
            buttonText: "Zurück",
            tooltipText: "Zur vorigen Seite zurückkehren"
        },
        searchBox: {
            placeholderText: "Suche..."
        },
        entry: 'Eintrag',
        newEntry: {
            buttonText: "Eintrag erstellen",
            tooltipText: "Einen neuen Eintrag hinzufügen"
        },
        currentEntry: "Momentaner Eintrag",
        editEntry: {
            buttonText: "Bearbeiten",
            tooltipText: "Diesen Eintrag bearbeiten"
        },
        deleteEntry: {
            buttonText: "Eintrag löschen",
            tooltipText: "Diesen Eintrag löschen"
        },
        restoreEntry: {
            buttonText: "Wiederherstellen",
            tooltipText: "Diesen Eintrag wiederherstellen"
        },
        cancel: {
            buttonText: "Abbrechen",
            tooltipText: "Abbrechen und zurück"
        },
        isDeleted: "Gelöscht",
        showDetail: {
            buttonText: "Detail anzeigen",
            tooltipText: "Das Detail dieses Eintrages anzeigen"
        },
        sorting: {
            buttonText: "Sortierung",
            tooltipText: "Ändern sie die Sortierung der Daten auf dieser Seite."
        },
        sortAsc: {
            buttonText: "Aufsteigend sortieren",
            tooltipText: "Aufsteigend sortieren"
        },
        sortDesc: {
            buttonText: "Absteigend sortieren",
            tooltipText: "Absteigend sortieren"
        },
        filterButton: {
            buttonText: "Filter",
            tooltipText: "Setzen sie Filter um die angezeigten Einträge einzugrenzen"
        },
        backToHome: {
            tooltipText: "Zur Zentrale springen"
        },
        markAsRead: {
            buttonText: "Gelesen",
            tooltipText: "Als gelesen markieren"
        },
        markAsUnread: {
            buttonText: "Ungelesen",
            tooltipText: "Als ungelesen markieren"
        },
        expandText: {
            buttonText: "Text ausklappen",
            tooltipText: "Ganzen Text anzeigen"
        },
        contractText: {
            buttonText: "Text einklappen",
            tooltipText: "Nur kurzen Text anzeigen"
        },
        closeButton: {
            buttonText: "Schließen",
            tooltipText: "Schließen"
        },
        jumpToEntry: {
            buttonText: "Zum Eintrag",
            tooltipText: "Zum Eintrag springen"
        },
        stepForward: {
            buttonText: "Weiter",
            tooltipText: "Nächster Schritt"
        },
        resetButton: {
            buttonText: "Zurücksetzen"
        },
        submitButton: {
            buttonText: "Speichern"
        },
        confirmDelete: {
            question: "Eintrag löschen",
            standardText: "Wollen sie diesen Eintrag wirklich löschen?"
        },
        confirmRestore: {
            question: "Eintrag wiederherstellen",
            standardText: "Wollen sie diesen Eintrag wirklich wiederherstellen?"
        },
        inputSwitch: {
                labelTrue: "Ja",
                labelFalse: "Nein"
        },
        importantTitle: "Wichtig",
        tabBaiscInfo: "Stammdaten",
        per: "pro",
        yes: "Ja",
        no: "Nein",
        address: "Adresse",
        disablePlaceSearch: {
            helpText: "Wenn deaktiviert muss / kann die Adresse komplett eingegeben werden.",
            title: "Adressen-Suche aktiv"
        },
        street: "Straße",
        houseNumber: "Hausnummer",
        country: "Land",
        city: "Stadt",
        postal: "PLZ",
        province: "Bundesland",
        name: "Name",
        office: "Büro",
        contactPlural: 'Kontakte',
        contactSingular: 'Kontakt',
        allowed: "Erlaubt?",
        module: "Modul",
        begin: "Beginn",
        end: "Ende",
        userDefined: "Benutzerdefiniert",
        notAssigned: "Nicht zugewiesen",
        selectPlaceholder:"Auswählen",
        lockStatusTitle: {
            buttonText: "Sperrstatus",
            tooltipText: "Gibt den Sperrstatus des Eintrages an. Möglichkeiten sind Offen, Intern gesperrt, Extern gesperrt und komplett gesperrt."
        },
        lockStatus: {
            0: {
                title: "Offen",
                tooltip: "Der Eintrag kann verändert werden"
            },
            1: {
                title: "Extern",
                tooltip: "Extern geschlossen: Der Eintrag ist in Rechnung gestellt und kann nicht mehr verändert werden."
            },
            2: {
                title: "Intern",
                tooltip: "Intern geschlossen: Der Eintrag ist intern abgerechnet ( zum Beispiel für die Stundenauswertung ). Der Eintrag ist nur noch teilweise veränderbar"
            },
            3: {
                title: "Geschlossen",
                tooltip: "Der Eintrag nicht nicht mehr verändert werden."
            }
        },
        tag: {
            buttonText: "Bezeichner",
            tooltipText: "Begriffe, welche den Eintrag beschreiben. Über diese Begriffe kann man Einträge mit gleichen Bezeichnern schnell finden."
        },
        category: {
            buttonText: "Kategorie",
            tooltipText: "Möglichkeit einen Eintrag in einer Kategorie mit anderen ähnlichen Einträgen abzulegen."
        },
        dateName: 'Datum',
        attachment: {
            buttonText: "Anhang",
            tooltipText: "Anhänge"
        }
    },
    ajaxResponse: {
        informAdmin: "Sollte das Problem beständig auftreten wenden sie sich an den Administrator!",
        savingSuccess: "Eintrag wurde erfolgreich gespeichert.",
        deleteSuccess: "Eintrag wurde erfolgreich gelöscht.",
        restoreSuccess: "Eintrag wurde erfolgreich wiederhergestellt",
        errors: {
            errorAppeared: ( view, action ) => `Der Fehler trat auf in ${ view }::${ action }.`,
            400: 'Die Anfrage konnte vom API-Server nicht verarbeitet werden! Das könnte durch fehlerhafte Einträge in Formularen passieren.',
            401: 'Die angefragte Resource wurde nicht gefunden!',
            404: `Der angegebene Pfad existiert auf dem API-Server nicht! `,
            500: 'Der Backend-Server meldet einen internen Fehler!',
            loginUserNotFound: 'Diese Email existiert nicht im System!',
            loginWrongPassword: 'Das Password ist nicht korrekt!'
        },
    },
    groups: {
        title: "Nutzergruppen",
        rowAreas: "Bereiche",
        rowName: "Name",
        rowDataBased: "Datenbasierte Gruppe?",
        form: {
            stepBasicInfoLabel: "Nutzergruppe Stammdaten",
            stepPrivilegesLabel: "Rechtevergabe",
            dataBasedHelperText: "Datenbasierte Gruppe bedeutet, das die Privilegien der Gruppe nur Kraft treten, wenn der Mitarbeiter auch einem Datensatz in dem Bereich zugeordnet ist. Beispiel: Max ist in der Gruppe Projektmitarbeiter, er müsste Projekte sehen. Die Gruppe ist aber datenbasiert, also sieht er keine Projekte denen er nicht zugeordnet ist."
        }
    },
    cookieBanner: {
        title: "Verwendung von Cookies",
        description: "Wir übermitteln personenbezogene Daten an Drittanbieter, um unser Webangebot zu verbessern. In diesem Zusammenhang werden auch Nutzungsprofile (u.a. auf Basis von Cookie-IDs) gebildet und angereichert, auch außerhalb des EWR. Hierfür und um bestimmte Dienste zu nachfolgenden Zwecken verwenden zu dürfen, benötigen wir Ihre Einwilligung. Indem Sie “Akzeptieren” klicken, stimmen Sie diesen zu. Dies umfasst auch Ihre Einwilligung in die Übermittlung bestimmter personenbezogener Daten in Drittländer, u.a. die USA, welches als unsicheres Drittland gilt.",
        decline: "Ablehnen",
        consent: "Akzeptieren"
    },
    versionCheck: {
        title: "Update verfügbar",
        message: "Eine neue Version der Anwendung ist verfügbar. Bitte laden Sie die Seite neu, um Probleme zu vermeiden.",
        reload: "Neu laden"
    },
    timesheet: {
        title: "Zeiterfassung",
        hoursCurrentWeek: "Stunden diese Woche",
        hoursCurrentWeekWithArgs: ( mandatoryHours: number | string, realHours: number | string ) => `Sie haben in dieser Woche ${realHours} von  ${mandatoryHours} Stunden gearbeitet`,
        hoursPerWeek: "Stunden pro Woche",
        mandatoryHours: "Pflichstunden",
        realHours: "Tatsächliche Stunden",
        rowTask: "Leistung",
        rowHoursOfWork: "Arbeitszeit",
        rowTime: "Tageszeit",
        timeOfEntry: "Eintragszeit",
        serialAppointment: "Serientermin",
        serialAppointmentPlural: "Serientermine",
        form: {
            journey: "Anfahrt nötig",
            weight: "Gewichtung in %",
            startDate: "Datum",
            endDate: "Bis",
            checkboxEnddate: "Serientermin anlegen",
            predefinedDescriptions: "Vorgefertigte Beschreibungen",
            description: "Leistungsbeschreibung",
            checkboxContainer: "Optionen",
            wholeDay: "Ganztags",
            internalHelp: "Interne Einträge in der Zeiterfassung beziehen sich immer auf interne arbeiten. Diese schließen auch Abwesenheit ( Urlaub, Krankheit...) ein. \n\n Interne Einträge werden in der Zeiterfassung und im Kalender gelb angezeigt.",
            seriesAppointmentHelp: "Wenn Serientermine gewählt werden wird diese Leistung an Arbeitstagen des Mitarbeiters erstellt. Wieviele erstellt werden hängt von dem gewählten Interval ab. \n\n **Serientermine enden nach spätestens einem Jahr.**",
            wholeDayHelp: 'Für diesen Eintrag wird die Arbeitszeit, anhand des für den Mitarbeiter hinterlegten Daten, automatisch berechnet. \n\n Um die Eingabe zu erleichtern kann man auch ein "Bis-Datum" setzen, das Programm erstellt dann an jedem Arbeitstag einen Eintrag mit voller Arbeitszeit. **Dies bietet sich vor allem für Urlaub oder Krankheit an.**',
            mandatoryDescriptionMissing: "Diese Leistung erfordert die Eingabe einer Beschreibung!"
        },
        series: {
            dateInterval: {
                0: "Täglich",
                1: "Wöchentlich",
                2: "Alle zwei Wochen",
                3: "Monatlich",
                4: "Jährlich"
            },
            finishAt: "Ende der Serie",
            interval: "Interval",

        },
        confirmSeriesSelection: {
            text: 'Wählen sie die Einträge, welche auch geändert werden sollen.'
        }
    },
    help: {
        title: "Hilfe"
    },
    notification: {
        title: "Benachrichtigungen",
        unreadNotificationTitle: "Ungelesene Benachrichtigungen",
        unreadNotificationsWithArgs: ( unreadNotifyCount: number ) => `Sie haben ${ unreadNotifyCount } ungelesene Benachrichtigungen`,
        noUnreadNotifications: "Sie haben keine ungelesenen Benachrichtigungen",
    },
    userSettings: {
        title: "Kontoverwaltung",
        mainMenuTooltip: "Navigation öffnen",
        columnSelector: {
            title: "Spaltenwahl",
            button: {
                buttonText: "Spaltenwahl",
                tooltipText: "Blenden sie Spalten ein oder aus, um die Tabelle zu verkleinern oder mehr Informationen anzuzeigen."
            }
        },
        rowsPerPage: 'Einträge pro Seite',
        toPage: (page: number ) => `Seite ${page} anzeigen`,
        nextPage: 'Nächste Seite',
        previousPage: 'Seite zurück',
        currentPage: 'Momentane Seite',
        totalEntries: ( totalEntries: number ) => `Gesamte Einträge: ${ totalEntries }`,
        activeFilters: 'Aktive Filter',
        viewSettings: {
            buttonText: "Seiteneinstellungen",
            tooltipText: "Speichern sie Seiteneinstellungen und rufen gespeicherte Einstellungen wieder auf."
        },
        defaultSettings: "Grundeinstellungen",
        saveSettings: "Einstellungen speichern",
        refreshData: "Daten aktualisieren"
    },
    projects: {
        retailPricePerHour: {
            helpText: "Der Verkaufspreis pro Stunde",
            title: "Verkaufspreis pro Stunde",
            shorthand: "VK / Std."
        },
        purchasePricePerHour: {
            helpText: "Der Einkaufspreis pro Stunde",
            title: "Einkaufspreis pro Stunde",
            shorthand: "EK / Std."
        },
        projectReport: {
            title: "Projektbericht"
        },
        saveAndLeave: "Speichern und verlassen",
        basedOn: "Basiert auf ",
        basedOnStageHelper: "Dieser Nachtrag basiert auf der ausgewählten Stufe / dem ausgewählten Nachtrag",
        addAddendum: "Nachtrag erstellen",
        currentPerformance: {
            title: "Aktueller Leistungsstand",
            helpText: "Der aktuelle Leistungsstand im Projekt."
        },
        newPerformance: {
            title: "Neuer Leistungsstand",
            helpText: "Der Leistungsstand nach dem Speichern."
        },
        performancePluralEdit: {
            title: "Leistungsstände bearbeiten",
            helpText: "Alle Leistungsstände des Bereiches übersichtlich auf einer Seite bearbeiten."
        },
        workingPeriod: {
            title: "Mitarbeitszeitraum",
            shorthand: "Mitarbeitszeit.",
            helpText: "Der Mitarbeitszeitraum gibt an, von wann bis wann der Mitarbeiter in einer Leistung tätig war. Seine Rechte in der Leistung gelten nur in diesem Zeitraum. Außerhalb des Zeitraums kann er auch keine Zeiten mehr eintragen."
        },
        avgPurchasePricePerHour: {
            title: "Durchschnittlicher Einkaufspreis pro Stunde",
            shorthand: "Durchs. EK / Std.",
            helpText: "Der durchschnittliche Einkaufspreis pro Stunde."
        },
        avgRetailPricePerHour: {
            title: "Durchschnittlicher Verkaufspreis pro Stunde",
            shorthand: "Durchs. VK / Std.",
            helpText: "Der durchschnittliche Verkaufspreis pro Stunde."
        },
        optionalRetailPrice: {
            helpText: "Optionaler Verkaufspreis ist ein Wert, welcher Potentiale für weitere Verkäufe angibt. Wie zum Beispiel Optionale Projektteile, welche beauftragt werden könnten.",
            shorthand: "Opt. VK",
            title: "Optionaler Verkaufspreis"
        },
        newEntry: {
            buttonText: "Projekt erstellen",
            tooltipText: "Einen neue Projekt hinzufügen"
        },
        editEntry: {
            buttonText: "Projekt bearbeiten",
            tooltipText: "Dieses Projekt bearbeiten"
        },
        deleteEntry: {
            buttonText: "Projekt löschen",
            tooltipText: "Dieses Projekt löschen"
        },
        restoreEntry: {
            buttonText: "Projekt Wiederherstellen",
            tooltipText: "Dieses Projekt wiederherstellen"
        },
        profitMargin: "Gewinnmarge",
        profitMarginPercent: "Gewinnmarge in %",
        status: {
            INACTIVE: "Inaktiv",
            ACTIVE: "Aktiv",
            PAUSED:"Pausiert",
            DONE:"Erledigt",
            LOCKED: "Geschlossen"
        },
        title: "Projekte",
        addendum: "Nachtrag",
        order: "Auftrag",
        mainOrder: {
            title: "Hauptauftrag",
            helpText: "Hauptauftrag VK ist das gesamte Volumen des beauftragten Projektes. In diesem Wert sind nicht die Nachträge inkludiert."
        },
        totalOrder: {
            title: "Gesamtauftrag",
            helpText: "Gesamtauftrag VK ist das gesamte Volumen des beauftragten Projektes. Gesamtauftrag = Hauptauftrag + Summe Nachträge",
        },
        internalWorkOrder: {
            title: "Eigenauftrag",
            helpText: "Eigenauftrag VK des beauftragen Projektes. Nachträge sind nicht inkludiert."
        },
        contractedWorkOrder: {
            title: "Fremdauftrag",
            helpText: "Fremdauftrag VK des beauftragen Projektes. Nachträge sind nicht inkludiert."
        },
        jumpToProjectWithArgs: ( projectTitle: string ) => `Zum Projekt ${ projectTitle } springen`,
        retailPriceUsed: "Budget verbraucht",
        rowProject: "Projekt",
        rowProjectStage: "Stufe",
        rowProjectStagePhase: "Leistungsphase",
        health: 'Zustand',
        healthBad: 'Schlecht',
        healthOk: 'Gut',
        healthWarning: 'Warnung',
        projectLead: 'Projektleiter',
        projectLeadSubstitute: 'stellv. Projektleiter',
        budgetCondition: 'Budgetstand',
        performance: 'Leistungsstand',
        assignedManHours: "Zugewiesene Stunden",
        plannedManHours: "Geplante Stunden",
        plannedPurchasePrice: {
            title: 'Geplanter Einkaufspreis',
            shorthand: 'Geplanter EK',
            helpText: 'Der geplante Einkaufspreis gibt an, wie viel dieser Punkt die Firma laut Planung kosten wird.'
        },
        assignedPurchasePrice: {
            title: 'Zugewiesener Einkaufspreis',
            shorthand: 'Zugewiesener EK',
            helpText: 'Der zugewiesene Einkaufspreis gibt an, wie viel Geld bereits fest im Projekt veranschlagt ist. Dies kann zum Beispiel durch Verträge mit Fachplanern geschehen oder zugewiesene Stunden an Mitarbeiter.'
        },
        usedPurchasePrice: {
            title: 'Genutzter Einkaufspreis',
            shorthand: 'Genutzter EK',
            helpText: 'Der genutzte Einkaufspreis gibt an, wie viel Geld bereits an Fachplaner gezahlt wurde oder innerhalb des Unternehmens von Mitarbeiter durch gebuchte Stunden.'
        },
        additionalCosts: {
            title: 'Nebenkosten',
            helpText: 'Aufschlag auf den Verkaufspreis für Kosten wie: Konnektivität, Papier, Netzwerk Infrastruktur, ect...'
        },
        additionalCostsInPercent: {
            title: 'Nebenkosten in %',
            helpText: 'Prozentualer Aufschlag auf den Verkaufspreis für Kosten wie: Konnektivität, Papier, Netzwerk Infrastruktur, ect...'
        },
        projectAddress: "Adresse des Bauvorhabens",
        purchasePrice: {
            title: 'Einkaufspreis',
            shorthand: 'EK',
            helpText: 'Der Einkaufspreis gibt an, wie viel dieser Punkt die Firma kosten wird.'
        },
        retailPrice: {
            title: 'Verkaufspreis',
            shorthand: 'VK',
            helpText: 'Der Verkaufspreis gibt an, wie viel dieser Punkt den Auftraggeber kosten wird.'
        },
        hourlyInternalCosts: {
            title: 'Einkaufspreis pro Stunde',
            helpText: 'Aus den Kosten pro Arbeitsstunde wird z.B.: das genutzte Budget berechnet.'
        },
        hourlyRate: {
            title: 'Verkaufspreis pro Stunde',
            helpText: 'Bei Abrechnung nach Zeit wird dieser Wert genutzt um mit den Zeiterfassungseinträgen den Gesamtpreis zu berechnen.'
        },
        projectRole: {
            title: 'Rolle',
            helpText: 'Die Position im Projekt und die damit einhergehede Rechten und Pflichten.'
        },
        legacyProjectNumber: {
            title: 'Bestandsprojektnummer',
            helpText: 'Wenn das Projekt bereits vor der Einführung dieser Software existierte, sollte hier die bisherige Projektnummer angegeben werden.'
        },
        stageTypeSelect: {
            title: 'Stufentyp',
            helpText: 'Der Stufentyp bestimmt einige Eigenschaften der Stufe, eine intern bearbeitete Stufe benötigt andere Werte als eine extern bearbeitete.'
        },
        addPhaseButton: {
            tooltipText: 'Eine Projektphase anlegen',
            buttonText: 'Phase hinzufügen'
        },
        addStageButton: {
            tooltipText: 'Eine Projektstufe anlegen',
            buttonText: 'Stufe hinzufügen'
        },
        commissionAt: {
            tooltipText: 'Der Auftrag wurde an diesem Datum, vor Unterschrift des Vertrages, durch den Auftraggeber erteilt.',
            buttonText: 'Datum der Vorabbeauftragung'
        },
        contractSignatureDate: {
            tooltipText: 'An diesem Datum wurde der Vertrag vom Auftragnehmer unterschrieben.',
            buttonText: 'Datum der Vertragsunterzeichnung Auftragnehmer'
        },
        contractSignatureCustomerDate: {
            tooltipText: 'An diesem Datum hat der Auftraggeber den Vertrag unterschrieben.',
            buttonText: 'Datum der Vertragsunterzeichnung Auftraggeber'
        },
        workHoursUsed: {
            tooltipText: "Von Mitarbeitern auf das Projekt/Stufe/Phase gebuchte Stunden",
            buttonText: "Verbrauchte Std."
        },
        stageTypes: {
            stage_addendum_external: {
                title: 'Nachtrag Extern',
                helpText: 'Diese Stufe beinhaltet einen Nachtrag, welcher von einem Subunternehmer bearbeitet wird.'
            },
            stage_addendum_internal: {
                title: 'Nachtrag Intern',
                helpText: "Diese Stufe beinhaltet einen Nachtrag, welcher intern bearbeitet wird."
            },
            stage_external: {
                title: 'Extern',
                helpText: 'Diese Stufe wird von einem Subunternehmer bearbeitet'
            },
            stage_internal: {
                title: 'Intern',
                helpText: 'Diese Stufe wird intern bearbeitet.'
            }

        },
        plannedProfitMargin: "Geplante Marge",
        assignedProfitMargin: {
            title: "Virtuelle Gewinnmarge",
            helpText: "Die virtuelle Gewinnmarge errechnet sich aus dem Verkaufspreis minus zugewiesener Einkaufspreise für Mitarbeiter, Fachleister und anderer Kosten für die Firma."
        },
        form: {
            phaseExistsError: "Diese Leistungsphase existiert in der gewählten Stufe bereits! Wenn sie Leistungen hinzufügen möchten, bearbeiten sie bitte die existierende Leistungsphase!",
            stepTitleBasicInfo: 'Stammdaten',
            shortDescription: {
                title: 'Kurzer identifizierender Name',
                helpText: 'Wird in der Software immer zusammen mit der Projektnummer angezeigt.',
            },
            description: 'Beschreibung',
            projectStageCreate: {
                buttonText: "Stufe erstellen",
                tooltipText: "Erstellen sie in diesem Projekt eine neue Stufe"
            },
            projectPhaseCreate: {
                buttonText: "Phase erstellen",
                tooltipText: "Erstellen sie in dieser Stufe eine neue Projektphase"
            },
            plannedCosts: "Geplante Kosten",
            budget: "Budget",
            phaseSubmitButtonText: "Phase übernehmen",
            projectSubmitButtonText: "Projekt speichern",
            stageSubmitButtonText: "Stufe übernehmen",
            employeeSubmitButtonText: "Mitarbeiter übernehmen",
            addContractor: "Fachplaner hinzufügen",
            addEmployee: "Mitarbeiter hinzufügen"
        },
        projectBillType: {
            none: "Keine Abrechnung",
            partial_invoice: "Abschlagsrechnung",
            single_invoice_flat: "Pauschale Abrechnung ( Einzelrechnung )",
            single_invoice_time: "Zeitbasierte Abrechnung ( Einzelrechnung )"
        },
        timeRetailPricePerHourType: {
            flat_based: "Einheitlicher Stundensatz",
            role_based: "Rollenbasierter Stundensatz"
        }
    },
    errors: {
        title: "Fehler",
        defaultFallback: "Für die Resource wurde der Standardwert gesetzt.",
        sensitive: {
            notPermitted: { errorText: "Sie besitzen keine Berechtigung für diese Resource!" },
            notFound: { errorText: "Diese Resource wurde nicht gefunden!" },
            corrupted: { errorText: "Diese Resource ist beschädigt!" },
            typeError: { errorText: "Diese Resource entspricht nicht dem erwarteten Typ!" }
        },
        errorBoundaryMessage: {
            errorText: 'Ein fataler Fehler ist aufgetreten, bitte aktualisieren sie mit STRG + R ( macOs: CMD + R  ) die Seite! Sollte der Fehler fortbestehen informieren sie den Administrator!'
        },
        pageAccessDenied: {
            errorText: "Sie besitzen nicht die nötigen Rechte um diese Seite zu betreten!"
        },
        noData: {
            errorText: "Keine Daten gefunden!",
        },       
        form: {
            notANumber: {
                errorText: "In diesem Feld sind nur Zahlen oder . und , erlaubt."
            },
            requiredFieldNotFilled: {
                errorText: "Diese Feld muss zwingend ausgefüllt werden!"
            },
            savingFormFailed: {
                errorText: "Eintrag konnte nicht gespeichert werden!"
            },
            overMax: { errorText: "Werte dürfen nicht größer als $$[max] sein!" },
            underMin: { errorText: "Werte dürfen nicht kleiner als $$[min] sein!" },
            passwordDontMatch: { errorText: "Die eingegebenen Passwörter müssen gleich sein!" },
            dateEarlierThan: ( date: Date ) => `Das gewählte Datum muss vor dem ${ format( date, DateFormat ) } liegen!`,
            dateLaterThan: ( date: Date ) => `Das gewählte Datum muss nach dem ${ format( date, DateFormat ) } liegen!`,
            dateNotParseable:{ errorText: "Das eingegebene Datum konnte nicht verifiziert werden, bitte nur das Format TT.MM.YYYY verwenden" },
            timeEarlierThan: ( date: Date ) => `Die gewählte Zeit muss vor ${ format( date, DateTimeFormat ) } liegen!`,
            timeLaterThan: ( date: Date ) => `Die gewählte Zeit muss nach ${ format( date, DateTimeFormat ) } liegen!`,
            timeNotParseable:{ errorText: "Die eingegebene Zeit konnte nicht verifiziert werden, bitte nur das Format SS:MM verwenden" },
            emailAlreadyExists: { errorText: "Diese Email-Adresse existiert bereits, bitte wählen sie eine andere!" },
            exceedsLimit: ( limit: string ) => "Der eingegebene Wert ist über dem Limit von "+ limit
        }
    },
    privileges: {
        'view.can_view': { title: "Kann Seite betreten", helpText: "Soll der Nutzer diese Seite betreten können?"},
        'view.can_create': { title: "Kann Einträge erstellen", helpText: "Soll der Nutzer Einträge erstellen können?"},
        'view.can_edit': { title: "Kann Einträge bearbeiten", helpText: "Soll der Nutzer Einträge bearbeiten können?"},
        'view.can_delete': { title: "Kann Einträge löschen", helpText: "Soll der Nutzer Einträge löschen können?"},
        'can_restore': { title: "Kann Einträge wiederherstellen", helpText: "Soll der Nutzer Einträge wiederherstellen können?"},
        'can_access_sensitive': { title: "Kann sensitive Informationen sehen", helpText: "Soll der Nutzer sensitive Daten auf dieser Seite sehen können?"},
        'view.can_download_files': { title: "Kann Dateien herunterladen", helpText: "Soll der Nutzer Dateien herunterladen können?"},
        'can_add_users_to_user_group': { title: "Kann Mitarbeiter zu Nutzergruppen hinzufügen?", helpText: "Soll der Mitarbeiter in der Lage sein anderen Nutzern Nutzergruppen ( also deren Rechte erweitern ) zuzuweisen?" },
        'can_delete_users_from_user_group': { title: "Kann Mitarbeitern Nutzergruppen entziehen?", helpText: "Soll der Mitarbeiter in der Lage sein andere Nutzer aus Nutzergruppen ( also deren Rechte einzuschränken ) zu entfernen?" }
    },
    userManagment: {
        title: "Verwaltung",
        password: "Passwort",
        login: "Anmelden",
        logout: "Abmelden",
        mail: "E-Mail",
        register: "Registrieren",
        registerBtnTooltip: "Registrieren und Instanz erstellen",
        registerLink: "**Noch kein GibProject?**\n\nEröffnen Sie jetzt **kostenlos** Ihre eigene Demo-Instanz!",
        createInstance: "Registrieren und Instanz erstellen",
        registerDemoMarketingTextHeadline: "**Entdecken Sie GibProject – ganz ohne Risiko!**",
        registerTextHeadline: "**Los geht’s!**",
        registerText: "Füllen Sie einfach das Formular aus – Ihre GibProject-Instanz wird **automatisch für Sie erstellt**. In der Regel dauert das nur **wenige Minuten**. Sobald der Prozess abgeschlossen ist, können Sie sich direkt einloggen und loslegen.",
        registerDemoMarketingText: "Testen Sie GibProject jetzt **kostenlos** und erstellen Sie in wenigen Schritten Ihre eigene Instanz. Nutzen Sie **24 Stunden lang** die volle Demo-Version und überzeugen Sie sich selbst von den Möglichkeiten der Software. \n\nMöchten Sie mehr Zeit zum Ausprobieren oder eine persönliche, unverbindliche Präsentation? Wir beraten Sie gerne – einfach bei uns melden!\n\n *Starten Sie jetzt und erleben Sie, wie GibProject Ihre Projekte voranbringt.*\n",
        registerSend: "Vielen Dank für deine Registrierung. Deine Instanz wird gerade erstellt – dieser Vorgang dauert in der Regel **bis zu fünf Minuten**.\n\nSobald der Prozess abgeschlossen ist, kannst du dich mit deinen Login-Daten in deinem persönlichen Bereich einloggen und direkt loslegen!\n\n",
        registerSendHeadline: "**Willkommen bei GibProject!**"
    },
    employees: {
        employeeHoursReport: "Mitarbeiter Stundenauswertung",
        title: "Mitarbeiter",
        rowFirstName: "Vorname",
        rowLastName: "Nachname",
        rowMail: "E-Mail",
        rowShorthandName: "Kürzel",
        rowBirthday: "Geburtstag",
        password: "Passwort",
        repeatPassword: "Passwort wiederholen",
        setNewPassword: "Neues Passwort erstellen",
        addEmployeeButton: {
            tooltipText: 'Mitarbeiter hinzufügen',
            buttonText: 'Mitarbeiter hinzufügen'
        },
    },
    employeeDetailView: {
        title: "Mitarbeiter",
        tabContractInfo: "Vertragsdaten",
        tabHours: "Stundenabrechnungen",
        contractData: "Vertragsdaten",
        contactInfo: "Kontakt Informationen",
        personalInformation: "Persönliche Informationen",
        qualification: "Mitarbeiter-Qualifikation",
        qualificationPlural: "Mitarbeiter-Qualifikationen",
    },
    employeeContract: {
        contractualHoursOfOvertime: "Vertragl. abgegoltene Überstunden (pro Woche)",
        internalCostsPerHour: "Interne Kosten pro Stunde",
        employmentStatus: {
            employmentRelationship: "Arbeitsverhältnis",
            PERMANENT: "Festangestellt",
            APPRENTICE: "In Ausbildung",
            FREELANCER: "Freier Mitarbeiter",
            SHORT_TERM: "Befristete Anstellung",
            TRAINEE: "Praktikant",
            MINOR_EMPLOYMENT: "Geringfügig beschäftigt"
        },
        contractStart: "Vertragsbeginn",
        contractEnd: "Vertragsende",
        workdayFullTimeSelection: "Standard Arbeitswoche für Vollzeit",
        workdayPartTimeSelection: "Standard Arbeitswoche für Teilzeit"
    },
    calendar: {
        title: "Kalender",
        calendar: "Kalender",
        workBreak: "Pause",
        startDateAt: "Von",
        finishDateAt: "Bis",
        hoursOfWork: "Arbeitsstunden",
        workingHours: "Arbeitszeit",
        workingHoursPlural: "Arbeitszeiten",
        overtime: "Überstunden",
        daysOfVacation: "Urlaubstage",
        vacation: "Urlaub",
        sickness: "Krankheit",
        sicknessOfChild: "Krankheit des Kindes",
        periodOfTime: "Zeitraum",
        day: "Tag",
        hour: "Stunde",
        hourPlural: "Stunden",
        minute: "Minute",
        minutePlural: "Minuten",
        time: "Zeit",
        week: "Woche",
        month: "Monat",
        year: "Jahr",
        today: "Heute",
        nextMonth: "Nächster Monat",
        prevMonth: "Voriger Monat",
        nextWeek: "Nächste Woche",
        prevWeek: "Vorige Woche",
        nextDay: "Nächster Tag",
        prevDay: "Voriger Tag",
        months: {
            january: "Januar",
            february: "Februar",
            march: "März",
            april: "April",
            may: "Mai",
            june: "Juni",
            july: "Juli",
            august: "August",
            september: "September",
            october: "Oktober",
            november: "November",
            december: "Dezember"
        },
        weekdays: {
            sunday: "Sonntag",
            monday: "Montag",
            tuesday: "Dienstag",
            wednesday: "Mittwoch",
            thursday: "Donnerstag",
            friday: "Freitag",
            saturday: "Samstag"
        }
    },
    communication: {
        coms: {
            name: 'Bezeichnung',
            method: 'Methode',
            number: 'Nummer / Adresse',
            isPersonal: 'Privat',
            addContactOption: 'Kontaktmethode hinzufügen'
        },
        methods: {
            TELEPHONE: 'Telefon',
            MOBILE: 'Handy',
            MAIL: 'E-Mail',
            FAX: 'Fax',
        }
    },
    qualifications: {
        refreshRate: "Auffrischungsrate ( in Tagen )",
        lastRefresh: "Zuletzt erworben",
        nextRefresh: "Nächste Auffrischung",
        title: "Qualifikation",
        viewTitle: "Qualifikation",
        viewTitlePlural: "Qualifikationen"
    },
    project_phase_templates: {
        title: "Leistungsphasen-Vorlagen",
        shorthand: "Kürzel"
    },
    employers: {
        office: "Büro",
        title: "Arbeitgeber"
    },
    timesheet_tasks: {
        title: 'Leistungen',
        flagLabel: 'Flaggen',
        predefDescription: 'Textblöcke',
        flags: {
            SICKNESS: "Krankheit",
            HOLIDAY: "Urlaub",
            DESCRIPTION_MANDATORY: "Beschreibung erforderlich",
            ABSENCE: "Abwesend",
            INTERNAL: "Intern",
            SICKNESS_CHILD: "Krankheit Kind",
            HOLIDAY_UNPAID: 'Unbezahlter Urlaub',
            MATERNITY_LEAVE: 'Mutterschutz'
        }
    },
    projectLog: {
        title: 'Log',
        answer: {
            buttonText: 'Antwort',
            tooltipText: 'Erstellen sie eine Antwort auf diesen Logeintrag'
        },
        mention: {
            buttonText: 'Erwähnung',
            tooltipText: 'Erwähnen sie Mitarbeiter in dem Eintrag um diese Mitarbeiter auf den Eintrag aufmerksam zu machen'
        },
        headline: {
            buttonText: 'Überschrift',
            tooltipText: 'Kurze und möglichst prägnante Info über den Eintrag'
        },
        message: {
            buttonText: 'Nachricht',
            tooltipText: 'Nachricht'
        },
        category: {
            buttonText: 'Kategorie',
            tooltipText: 'Kategorisieren sie den Eintrag zusammen mit anderen ähnlichen Einträgen.'
        }
    },
    customers: {
        title: 'Auftraggeber',
        legacyCustomerNumber: {
            title: 'Kundennummer Bestand',
            helpText: 'Kundennummer des Auftraggebers vor der Einführung des Systems'
        },
        customerNumber: {
            title: 'Kundennummer',
            helpText: 'Kundennummer des Auftraggebers, vom System vergeben.'
        }
    },
    customerRevenueReport: {
        title: 'Kunden-Umsatz-Report',
        period: 'Zeitraum',
        revenue: 'Umsatz',
        openAmount: 'Offener Betrag',
        hoursWorked: 'Geleistete Stunden',
        contractorCosts: 'Fachplaner-Kosten',
        staffCosts: 'Personalkosten',
        totalCosts: 'Gesamtkosten',
        margin: 'Marge',
        netMargin: 'Bruttomarge',
        projects: 'Projekte',
        projectNumber: 'Projektnummer',
        shortDescription: 'Kurzbeschreibung',
        customerNumber: 'Kundennummer',
        sensitiveNotPermitted: 'Keine Berechtigung für diese sensible Information!',
        chartTitle: 'Umsatzanalyse in Euro €'
    },
    contractors: {
       title: 'Fachplaner'
    },
    externalWork: {
        title: "Honorarordnung",
        hasPhases: {
            buttonText: 'Besitzt Projektphasen',
            tooltipText: 'Abrechnung erfolgt über Leistungsphasen.'
        }
    },
    externalWorkGroup: {
        title: "Honorarordnung - Gruppen",
        numberOfPhases: "Anzahl Leistungsphasen",
        hasPhasesWithSameName: "Besitzt Leistungsphasen mit gleichem Namen wie die Gruppe ( zum Beispiel: LPH 1 Umweltveträglichkeitsstudie )",
        hasSpecializedPhaseNames: "Leistungsphasen mit speziellen Namen ( zum Beispiel: LPH 1 Elektro Grundleistungen )"

    },
    projectCommissionState: {
        title: 'Auftragsstatus',
        includeInBilling: 'Rechnungsposten'
    },
    projectSegmentFilter: {
        forProjects: 'Für Projekte',
        forProjectStage: 'Für Stufen',
        forProjectStagePhase: 'Für Phasen',
        forContractors: 'Für Fachplaner',
        forProjectTasks: 'Für Aufgaben'
    },
    projectRoles: {
        title: "Projektrolle",
        titleSingular: "Projektrolle",
        defaultPricePerHour: {
            title: "Standard VK / Stunde",
            helpText: "Der standardmäßig abgerechnete Preis für diese Leistung pro Stunde."
        },
        priceRange: {
            title: "Preisbereich",
            helpText: "In diesem Bereich darf der VK / Stunde geändert werden."
        },
        priceRangeMax: "Maximaler Preis pro Stunde",
        priceRangeMin: "Minimaler Preis pro Stunde",
    },
    accounting: {
        baseAmount: "Grundbetrag",
        singleItemPriceInclSurcharge: "Einzelpreis (inkl. Zuschlag/Nachlass)",
        addDiscountSurcharge: "Nachlass / Zuschlag hinzufügen",
        discount: "Nachlass",
        surcharge: "Zuschlag",
        discountPlural: "Nachlässe",
        surchargePlural: "Zuschläge",
        itemCount: "Anzahl",
        units: {
            unitPrice: "Preis einer Einheit",
            title:"Einheit",
            types: {
                piece: "Stück",
                hours: "Stunden",
                days: "Tage",
                percent: "Prozent",
                flatrate: "Pauschale",
                numberofitems: "Stückzahl"
            }
        },
        invoiceMethod: {
            title: "Rechnungsmethode",
            simpleInvoice: {
                title: "Einfache Rechnung",
                shorthand: "Einfache Rechnung",
                helpText: "In einer einfachen Rechnung geben sie alle Rechnungsposten manuell ein. Bitte beachten sie, das ein genaues Projektcontrolling nur mit Projektrechnungen möglich ist."
            },
            projectInvoice: {
                title: "Projektrechnung",
                shorthand: "Projektrechnung",
                helpText: "In einer Projektrechnung werden die Rechnungsposten aus den Leistungen eines Projekt übernommen."
            }
        },
        serialNumberOverride: {
            title: "Laufende Nummber überschreiben",
            helpText: "Wenn aktiviert, kann die laufende Nummer der Rechnung manuell überschrieben werden. Eine überschriebene Nummer muss immer auch reserviert sein!",
            shorthand: "Lfd.-Nr. überschreiben"
        },
        incomingInvoiceBookTitle: "Eingangsrechnungsbuch",
        paymentConditions: "Zahlungsbedingungen",
        paidByDate: "Zahlungsziel",
        paidByDateInDays: "Tage bis Zahlung eingegangen sein soll",
        bankAccountInfo: {
            bankAccountLabel: "Kontoverbindung",
            accountHolder: {
                title: "Kontoinhaber*in",
                helpText: "Name des Kontoinhabers / der Kontoinhaberin / des Unternehmens"
            },
            bankName: {
                title: "Bank",
                helpText: "Name der Bank."
            },
            iban: {
                title: "IBAN",
                helpText: "Abkürzung für Internationale Bankkontonummer  ( englisch: International Bank Account Number)"
            },
            bic: {
                title: "BIC",
                helpText: "Abkürzung für Business Identifier Code ( ehemals Bank Identifier Code )"
            }
        },
        customer: {
            projectName: {
                title: "Projektname beim Kunden",
                shorthand: "Projektname beim Kunden",
                helpText: "Name des Projekts beim Kunden, der in der Rechnung und E-Rechnung angezeigt wird. Wenn ausgefüllt ist die Angabe einer Projektnummer pflicht."
            },
            supplierNumber: {
                title: "Lieferantennummer beim Kunden",
                shorthand: "Lief.-Nr. Kunde",
                helpText: "Lieferantennummer vom Kunden vorgegeben"
            },
            orderNumber: {
                title: "Bestellnummer",
                shorthand: "Best.-Nr.",
                helpText: "Bestellnummer vom Kunden vorgegeben"
            },
            contractNumber: {
                title: "Vertragsnummer",
                shorthand: "Vertr.-Nr.",
                helpText: "Vertragsnummer vom Kunden vorgegeben"
            },
            projectNumber: {
                title: "Projektnummer des Kunden",
                shorthand: "Proj.-Nr. des Kunden",
                helpText: "Projektnummer vom Kunden vorgegeben. Wenn ausgefüllt ist die Angabe eines Projektnamen pflicht."
            },
            procurementReference: {
                title: "Vergabenummer",
                shorthand: "Verg.-Nr.",
                helpText: "Geben Sie hier die Vergabenummer ein, wenn die Rechnung im Rahmen einer Ausschreibung oder eines Loses einer Ausschreibung gestellt wird."
            },
            objectReference: {
                title: "Objektkennung",
                shorthand: "Obj.-Kennung.",
                helpText: "Hier können Sie eine Kennung für das fakturierte Objekt angeben, wie z.B. eine Zählernummer, eine Telefonnummer, ein Kfz-Kennzeichen, eine versicherte Person"
            }

        },
        vatId: "USt.-ID",
        title: "Ausgangsrechnungsbuch",
        invoiceItems: "Rechnungsposten",
        taxId: "Steuer-ID",
        leitwegId: {
            title: "Leitweg-ID",
            shorthand: "LW-ID",
            helpText: "Leitweg-ID ist eine deutsche Identifikationsnummer, welche vor allem bei öffentlichen Auftraggebern Verwendung findet."
        },
        netOfTax: {
            title: "Netto Betrag",
            shorthand: "Netto",
            helpText: ""
        },
        gross: {
            title: "Brutto Betrag",
            shorthand: "Brutto",
            helpText: ""
        },
        salesTax: {
            title: "Umsatzsteuer",
            shorthand: "USt.",
            helpText: ""
        },
        billedPerformance: "Leistungsstand abrechnen",
        lastBilledPerformance: "Leistungsstand letzte Rechnung",
        typeTitle: "Rechnungsart",
        invoiceNumber: "Rechnungsnummer",
        modeTitle: "Status",
        billedAmount: "Abgerechneter Betrag",
        mode: {
            canceled: "Storniert",
            done: "Finalisiert",
            inProcess: "In Arbeit"
        },
        serialNumber: {
            title: "Laufende-Nummer",
            shorthand: "Lfd-Nummer",
            helpText:"Die laufende Nummer ist nur vorläufig vergeben, sie wird zur aktuellen laufenden Nummer geändert, wenn die Rechnung abgeschickt wurde."
        },
        serialNumberProvisional: "vorläufig",
        serialNumberReserved: {
            title: "Lfd-Nummer reservieren",
            shorthand: "",
            helpText: "Die laufende Nummer bleibt auch nach dem finalisieren erhalten."
        },
        invoiceDate: "Rechnungsdatum",
        payedBillAmount: {
            title: "Bezahlter Rechnungsbetrag",
            shorthand: 'Bez. Betrag',
            helpText: "Der bisher bezahlte Betrag einer oder mehrerer Rechnungen."
        },
        openBillAmount: {
            title: "Offener Rechnungsbetrag",
            shorthand: 'Off. Betrag',
            helpText: "Die Differenz zwischen bezahltem und gefordertem Rechnungsbetrag."
        },
        uncheckedBillAmount: {
            title: "Geforderter Rechnungsbetrag",
            shorthand: 'Gefor. Betrag',
            helpText: "Der vom Fachplaner geforderte Betrag einer oder mehrerer Rechnungen"
        },
        prePayment: "Anzahlung",
        finalInvoiceAmount: "Rechnungsbetrag",
        type: {
            partialInvoice: {
                title: "Abschlagsrechnung",
                shorthand: "AR",
                helpText: ""
            },
            finalInvoice: {
                title: "Schlussrechnung",
                shorthand: "SR",
                helpText: ""
            },
            singleInvoice:{
                title: "Einzelrechnung",
                shorthand: "ER",
                helpText: ""
            }
        },
        incomingInvoice: {
            title: "Eingangsrechnung"
        },
        contractorBilledPerformance: "Fachplaner Leistungsstand (%)",
        approvedAmountOwed: "Genehmigter Rechnungsbetrag",
        contractorAmountBilled: "Fachplaner Rechnungsbetrag",
        approvedPerformance: "Genehmigter Leistungsstand",
        payments: "Zahlungen",
        payment: "Zahlung",
        uploadInvoice: "Rechnung hochladen",
        generateInvoice: "Rechnung automatisch generieren",
        chooseTemplate: "Rechnungsvorlage auswählen",
        invoiceFinalError: "Dieses Projekt besitzt bereits eine endgültige Schlussrechnung, sie können nur noch Einzelrechnungen hinzufügen. Falls die alte Schlussrechnung fehlerhaft war, stornieren Sie die alte, bevor sie eine neue anlegen.",
        cancel: "Stornieren",
        reminderToUseBookKeeping: "Bitte denken sie daran, diese Rechnung in ihrer Buchhaltung einzutragen!",
        finalize: "Finalisieren",
        finalizeConfirmText: "Wollen sie diese Rechnung wirklich finalisieren? Dieser Schritt kann nicht rückgängig gemacht werden.",
        cancelConfirmText: "Wollen sie diese Rechnung wirklich stornieren? Dieser Schritt kann nicht rückgängig gemacht werden.",
        invoiceForCanceled: "Stornorechnung für"
    },
    externalWorkArea: {
        title: "Fachbereich"
    },
    usercp: {
        title: "Benutzerkonto",
        settings: "Einstellungen"
    },
    mainMenu: {
        outgoing_invoice: { title: "Ausgangsrechnungsbuch" },
        incoming_invoice: { title: "Eingangsrechnungsbuch" },
        solvency_projection: { title: "Projekt Liquiditätsbericht" },
        project_report: { title: "Projektbericht" },
        project_roles: { title: "Projektrollen" },
        commission_state: { title: "Autragsstatus" },
        reporting_employees_hours: { title: "Mitarbeiter Stundenauswertung" },
        customer_revenue_report: { title: "Kunden-Umsatz-Report" },
        external_work_groups: { title: "Honorarordnung - Gruppen"},
        external_works: { title: "Honorarordnung" }
    },
    team: {
        title: "Team",
        newButton: {
            tooltipText: "Neues Team erstellen",
            buttonText: "Neues Team"
        },
        deleteButton: {
            tooltipText: "Team löschen",
            buttonText: "Löschen"
        },
        editButton: {
            tooltipText: "Team bearbeiten",
            buttonText: "Bearbeiten"
        }
    },
    api_keys: {
        title: "API Schlüssel",
        validUntil: "Gültig bis",
        keyInfoMsg: "Der API-Schlüssel wird benötigt, um die API zu nutzen. Bewahren sie den Schlüssel sicher auf. Die Nutzeroberfläche wird den Schlüssel niemals anzeigen. Falls er verloren geht, löschen sie den alten Schlüssel und generieren einen neuen."
    }

};